/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as React from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { makeStyles } from "@material-ui/core/styles";
import * as constantMessageData from "../../../../SharedModules/Errors/constantMessageData";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  input: {
    color: "red !important",
  },
}));
export default function ColorTabs(props) {
  const classes = useStyles();
  //props
  const { tabValue, handleChangeTabValue, errorMessagesArray} = props;
  return (
    <>
      <div data-testid="comment-tab" className={classes.root}>
        <AppBar
          position="static"
          sx={{ width: "100%" }}
          style={{ borderBottom: "1px solid #c9c8c5" }}
        >
          <Tabs
            value={tabValue}
            onChange={handleChangeTabValue}
            color="red"
            style={{ color: "red" }}
          >
            <Tab
              style={{ textTransform: "capitalize" }}
              value="one"
              label="Links"
              tabIndex={0}
            />
            <Tab
              style={{ textTransform: "capitalize" }}
              value="two"
              label="Address Info"
              tabIndex={0}
            />
            {(errorMessagesArray && errorMessagesArray.length > 0 && errorMessagesArray.filter(x => {
              return (x.includes(constantMessageData.EMAIL_INVALID) || x.includes(constantMessageData.PHONE_INVALID_ERROR) || x.includes(constantMessageData.ZIP4_REQUIRED))
            }).length > 0) && (
                <span className="tab-error">!</span>
              )}
            <Tab
              style={{ textTransform: "capitalize" }}
              value="three"
              label="User / Date Info"
              tabIndex={0}
            />
          </Tabs>
        </AppBar>
      </div>
    </>
  );
}
